export default class Lazy<Store> {
    private instance: Store;

    constructor(private readonly createStore: () => Store) {}

    public get store(): Store {
        if (!this.instance) {
            this.instance = this.createStore();
        }

        return this.instance;
    }
}
